const SgiTabsEO = function () {
    return {
        atvTab: "",
        ctlH: '100%',
        ctlW: '100%',
        desId: "EP_EO_UI_4102",
        tabPst: "top",
        type: "card",
        // tabLsn: "tool.sgiLogger.log('tab切换监听，activeKey：',activeKey);",
        // clpDrt: "top",
        ctlN: "选项卡",
        // tbGutter: 0,//标题间隔
        // clpd : false,
        // csstyle : "tab-default",
        // flx : 0,
        // iconPh : "SD_RP_IR_0001`UI`UI04",
        // isBdyBrdr : true,
        // isBrdr : false,
        // isClp : false,
        // isClpFst : true,
        // isCls : false,
        // isDis : false,
        // isFrm : false,
        // isHClpTl : false,
        // isHdn : false,
        // isRead : false,
        // isScl : false,
        // isTtl : false,
        // isttlClp : false,
        // mgn : "0 0 0 0",
        // n : "选项卡",
        // pad : "0 0 0 0",
        // plain : false,
        // sNo : 0,
        // sc : "funcTab",        
        // tabRta : "default",
        // te : "123",
        // ttlAlg : "top",
        // ttlAlgn : "left",
        // useTim : 0,
        // visible : true,
        // x : "0",
        // y : "0"       
    }
}
export { SgiTabsEO };
export default SgiTabsEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiTabsEO.js